import React from 'react';
import PropTypes from 'prop-types';
import { jobsTabs } from '../../config/constants';
import './style.css';

const TAB_CONFIG = {
  [jobsTabs.ACTIVE]: {
    labelKey: 'export:active',
  },
  [jobsTabs.FAVORITES]: {
    labelKey: 'export:favorites',
  },
  [jobsTabs.ARCHIVED]: {
    labelKey: 'export:archived',
  },
};

const ExportStatusBar = ({ currentTab, counts, onTabChange, t }) => {
  const tabs = [jobsTabs.ACTIVE, jobsTabs.FAVORITES, jobsTabs.ARCHIVED];

  return (
    <div className="export-tabs">
      {tabs.map((tab) => {
        const config = TAB_CONFIG[tab];
        const isActive = currentTab === tab;
        const count = counts[tab];
        // Show count badge if we have a count (including 0), but not if null (not yet loaded)
        const showCount = count !== null && count !== undefined && count > 0;

        return (
          <button
            key={tab}
            className={`export-tab ${isActive ? 'export-tab--active' : ''}`}
            onClick={() => onTabChange(tab)}
            type="button"
          >
            <span className="export-tab-label">
              {t(config.labelKey)}
            </span>
            {showCount && (
              <span className="export-tab-count">{count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

ExportStatusBar.propTypes = {
  currentTab: PropTypes.string.isRequired,
  counts: PropTypes.shape({
    [jobsTabs.ACTIVE]: PropTypes.number,
    [jobsTabs.FAVORITES]: PropTypes.number,
    [jobsTabs.ARCHIVED]: PropTypes.number,
  }),
  onTabChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

ExportStatusBar.defaultProps = {
  counts: {},
};

export default ExportStatusBar;
